import { Injectable } from "@angular/core";
import { Adapter } from "./adapter";
import { GeoJsonLayer } from "./geo-json-layer";
import { Layer } from "./layer";
import { MaskLayer } from "./mask-layer";
import { WmsLayer } from "./wms-layer";
import { WmtsLayer } from "./wmts-layer";
import { GeoTiffLayer } from "./geo-tiff-layer";
import { GroupLayer } from './group-layer';
import { MapService } from '../services/map.service';
import { MapUtilsService } from "../services/map-utils.service";
import { WfsLayer } from "./wfs-layer";

@Injectable({
    providedIn: "root",
})
export class LayerAdapter implements Adapter<Layer> {

    constructor(private mapService: MapService,
        private mapUtilsService: MapUtilsService
    ) { }

    adapt(layerPayload: any): Layer {
        let id: string;
        let layerNotTyped: any;

        for (const [key, value] of Object.entries(layerPayload)) {
            id = key;
            layerNotTyped = value;
        }

        switch (layerNotTyped.type) {
            case "wms": {
                return new WmsLayer(
                    id,
                    layerNotTyped.label,
                    layerNotTyped.type, 
                    layerNotTyped.wmsUrl,
                    this.mapService.getMap().getView().getProjection().getCode(),
                    layerNotTyped.wmsLayers,
                    layerNotTyped.format,
                    layerNotTyped.minScaleDenominator,
                    layerNotTyped.maxScaleDenominator,
                    layerNotTyped.base, 
                    layerNotTyped.singleTile,
                    layerNotTyped.themes,
                    layerNotTyped.hasLegend,
                    // (layerNotTyped.tileLoadFunction) ? this.mapUtilsService.getTileloadFunction() : ''
                );
                break;
            }
            case "wmts": {
              //  console.log('adaptor', layerNotTyped);
                
                return new WmtsLayer(
                    id,
                    layerNotTyped.metadataId,
                    layerNotTyped.layerName,
                    layerNotTyped.label,
                    layerNotTyped.type,
                    layerNotTyped.wmtsUrl,
                    layerNotTyped.format,
                    layerNotTyped.base,
                    layerNotTyped.singleTile,
                    layerNotTyped.tilegridExtent,
                    layerNotTyped.tilegridLevels,
                    this.mapService.getMap().getView().getProjection().getCode(),
                    layerNotTyped.minScaleDenominator,
                    layerNotTyped.maxScaleDenominator,
                    layerNotTyped.origin,
                    layerNotTyped.themes,
                    layerNotTyped.hasLegend,
                    layerNotTyped.notilesUrl,
                    layerNotTyped.clipHoleExtent,
                    layerNotTyped.tileSize,
                    typeof layerNotTyped.hasWebGlSupport === 'boolean' ? layerNotTyped.hasWebGlSupport : this.mapUtilsService.hasWebGlSupport,
                    // (layerNotTyped.tileLoadFunction) ? this.mapUtilsService.getTileloadFunction() : ''
                );

                break;
            }
            case "wfs": {
                return new WfsLayer(
                    id,
                    layerNotTyped.label,
                    layerNotTyped.type,
                    layerNotTyped.typeNames,
                    layerNotTyped.outputFormat,
                    this.mapService.getMap().getView().getProjection().getCode(),
                    layerNotTyped.minZoom,
                    layerNotTyped.maxZoom,
                    layerNotTyped.hasLegend,
                    layerNotTyped.url,
                    layerNotTyped.opacity
                );
                break;
            }
            case "GeoJSON": {
                return new GeoJsonLayer(
                    id, 
                    layerNotTyped.label, 
                    layerNotTyped.path, 
                    layerNotTyped.type, 
                    layerNotTyped.themes
                );
                break;
            }
            case "mask": {
                return new MaskLayer(
                    id, 
                    layerNotTyped.label, 
                    layerNotTyped.type, 
                    layerNotTyped.projection, 
                    layerNotTyped.maskType, 
                    layerNotTyped.coords
                );
                break;
            }
            case "layergroup": {
                let subLayersArray: Layer[] = layerNotTyped.layers.map((layer: any) => this.adapt(layer));
                return new GroupLayer(id, layerNotTyped.label, layerNotTyped.type, subLayersArray, layerNotTyped.themes, layerNotTyped.hasLegend);
                break;
            }
            case "GeoTIFF": {
                return new GeoTiffLayer(id, layerNotTyped.label, layerNotTyped.type, layerNotTyped.geotiffUrl);
                break;
            }

                return;
        }
    }
}